// Assumes there is a specific class that covers the whole landing
const siteIsBim = () => $('.bim-landing-container').length > 0;
const isNotMobile = () => window.matchMedia('(min-width: 768px)').matches;

const arrowPrev = '__arrow-prev';
const arrowNext = '__arrow-next';
const bullets = '__bullets';

// Categories slider setup, early return if no categories
const setupCategories = notMobile => {
  let $cat = $(".bim-categories__category");
  let catContainer = ".bim-categories";
  let pressButton = "press_category_button";

  if ($cat.length  < 1) return;

  notMobile ? $cat.removeClass("auto") : $cat.addClass("auto");

  // Animación a botón de categorías en mobile
  $cat.on('touchstart', function() {
    $(this).addClass(pressButton);
  });
  $cat.on('touchend', function() {
    $(this).removeClass(pressButton);
  });

  new Swiper(catContainer, {
    slidesPerView: 4,
    spaceBetween: 20,

    on: {
      init: () => $(catContainer).addClass("opacity")
    },

    navigation: {
      nextEl: catContainer + arrowNext,
      prevEl: catContainer + arrowPrev,
    },

    pagination: {
      el: catContainer + bullets,
      dynamicBullets: true,
    },

    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      767: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: true
      }
    }
  });
}

// Articles slider setup, only on mobile and if there are articles
const setupArticles = (notMobile) => {
  let noArticles = $('.articles.swiper-container').length < 1;
  if (notMobile || noArticles) return;

  new Swiper('.articles', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    centerSlides: true
  });
}

// Manufacturers slider setup, early return if no manufactuers
const setupManufactuers = (notMobile) => {
  let $manufacturersLink = $(".bim-manufacturers__enlace");
  let $manufacturers = '.bim-manufacturers';

  if ($manufacturersLink.length < 1) return;

  notMobile ? $manufacturersLink.removeClass("auto") : $manufacturersLink.addClass("auto");

  new Swiper($manufacturers, {
    slidesPerView: 4,
    spaceBetween: 20,

    navigation: {
      nextEl: $manufacturers + arrowNext,
      prevEl: $manufacturers + arrowPrev,
    },

    pagination: {
      el: $manufacturers + bullets,
      dynamicBullets: true,
    },

    breakpoints: {
      767: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true
      }
    }
  });


}

export function bimSetup() {
  if(!siteIsBim()) return;

  var notMobile = isNotMobile();
  setupCategories(notMobile);
  setupArticles(notMobile);
  setupManufactuers(notMobile);
}


